

  import api from '@/api/index';
  import {Component, Vue, Watch} from "vue-property-decorator";
  import PagedTableView from '@/components/PagedTableView/index.vue';
  import {IncomeRecordDto, PaymentCategoryDto, PaymentCategoryScope} from "@/api/appService";
  import EditIncomeRecord from "@/views/pays/components/edit-incomeRecord.vue";
  import util from '@/utils/filter'
  import ExportButton from "@/components/ExportButton/index.vue";
  import PaymentCategorySelect from "@/components/PaymentCategorySelect/index.vue";


  @Component({name:'IncomeRecordList',components:{
      PaymentCategorySelect,
      ExportButton,
      PagedTableView,
      EditIncomeRecord
    }})
  export default class IncomeRecordList extends Vue{

    private queryForm:any = {
      categoryId:null,
      remark:'',
      incomeDateStart:undefined,
      incomeDateEnd:''
    };
    private currentEditId:number = 0;
    private incomeDate:string ='';



    get scopeFilter(){
      return PaymentCategoryScope.IncomeRecord;
    }

    @Watch('incomeDate')
    onIncomeDateChange(value:any){
      if(value && value.length){
        this.queryForm.incomeDateStart = util.formatDate(value[0],'YYYY-MM-DD');
        if(value.length > 0){
          this.queryForm.incomeDateEnd = util.formatDate(value[1],'YYYY-MM-DD');
        }
      } else {
        this.queryForm.incomeDateStart = '';
        this.queryForm.incomeDateEnd = '';
      }

    }

    get incomeDatePickOption(){
      return {
        shortcuts: [{
          text: '最近一周',
          onClick(picker:any) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker:any) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker:any) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      };
    }

    fetchData(params:any){
      return api.incomeRecord.getAll(params);
    }

    handleEdit($row:IncomeRecordDto){
      this.currentEditId = $row.id!;
      (this.$refs.editIncomeRecord as any).show = true;
    }

    handleCreate(){
      this.currentEditId = 0;
      (this.$refs.editIncomeRecord as any).show = true;
    }

    handleDelete($row:IncomeRecordDto){
      this.$confirm("你确定删除吗?", "提示").then(async () => {
        await api.incomeRecord.delete ({ id: $row.id }).then(res => {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
          (this.$refs.pagedTableView as any).refreshData();
        });
      });
    }
  }
